import { Component, Input } from '@angular/core';
import { faClose, faPlus, faRightLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'sketch-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent {

  faPlus = faPlus;
  faClose = faClose;
  faRightLeft = faRightLeft;

  @Input() text: string = '';
  @Input() type: string = 'primary';
  @Input() opt: string = '';
  @Input() size: string = 'medium';

  theIcon: any = null;
  theClass: string = '';

  ngOnInit() {
    this.theIcon = this.decipherIcon();
    this.theClass = this.decipherClass();
  }
  ngOnChanges() {
    this.theIcon = this.decipherIcon();
    this.theClass = this.decipherClass();
  }

  decipherIcon() {
    switch (this.opt) {
      case 'add':
        return faPlus;
      case 'close':
        return faClose;
      case 'swap':
        return faRightLeft;
    }
    return null;
  }

  decipherClass() {
    let colourClass = 'bg-primary';
    switch (this.type) {
      case 'primary':
        colourClass = 'bg-primary';
        break;
      case 'close':
          colourClass = 'bg-close';
          break;
      case 'danger':
        colourClass = 'bg-danger';
        break;
      case 'blank':
        colourClass = 'bg-blank';
        break;
    }

    return colourClass + ' ' + this.size;
  }
}